import en from './en.json';
import sv from './sv.json';

export const messages = {
  en,
  sv,
};
